import React, { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "../components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { useToast } from "../hooks/use-toast";
import { signIn, signUp } from "../lib/api";
import { Link } from "react-router-dom";

export default function AuthPage(){
  const { toast } = useToast();
  const [signingIn, setSigningIn] = useState(false);

  async function handleSignIn(e){
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const email = fd.get('email');
    const password = fd.get('password');
    try{
      setSigningIn(true);
      const res = await signIn({ email, password });
      localStorage.setItem('hourslaw.token', res.token);
      window.location.href = '/';
    }catch(err){
      let msg = 'Check your credentials and try again.';
      if (err?.response?.data?.detail) msg = err.response.data.detail;
      toast({ title: 'Sign in failed', description: msg });
    }finally{ setSigningIn(false); }
  }

  async function handleSignUp(e){
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const name = fd.get('name');
    const email = fd.get('email');
    const password = fd.get('password');
    const inviteCode = fd.get('inviteCode') || undefined;
    try{
      setSigningIn(true);
      const res = await signUp({ name, email, password, inviteCode });
      localStorage.setItem('hourslaw.token', res.token);
      window.location.href = '/';
    }catch(err){
      let msg = 'You do not have permission to sign up with that email address.';
      if (err?.response?.data?.detail) msg = err.response.data.detail;
      toast({ title: 'Sign up failed', description: msg });
    }finally{ setSigningIn(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>
            <span className="brand-red">sgt</span><span className="text-black">.</span><span className="text-black">law</span>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs defaultValue="signin">
            <TabsList className="grid grid-cols-2">
              <TabsTrigger value="signin">Sign in</TabsTrigger>
              <TabsTrigger value="signup">Sign up</TabsTrigger>
            </TabsList>
            <TabsContent value="signin" className="mt-4">
              <form onSubmit={handleSignIn} className="space-y-3">
                <Input name="email" type="email" placeholder="Email" required />
                <Input name="password" type="password" placeholder="Password" required />
                <Button disabled={signingIn} type="submit" className="w-full">Sign in</Button>
              </form>
            </TabsContent>
            <TabsContent value="signup" className="mt-4">
              <form onSubmit={handleSignUp} className="space-y-3">
                <Input name="name" placeholder="Full name" required />
                <Input name="email" type="email" placeholder="Work email" required />
                <Input name="password" type="password" placeholder="Password" required />
                <Input name="inviteCode" placeholder="Invite code (optional)" />
                <Button disabled={signingIn} type="submit" className="w-full">Create account</Button>
              </form>
            </TabsContent>
          </Tabs>
        </CardContent>
        <CardFooter>
          <div className="text-xs text-muted-foreground space-y-1">
            <p className="font-medium text-foreground">Legal notice</p>
            <p>This platform and website are not for public use. sgt.law is an organizational platform developed for invitation-only use by participating organizations. If you do not have an invitation, do not attempt to create an account or use this service.</p>

          </div>
        </CardFooter>
      </Card>
    </div>
  );
}